import { render, staticRenderFns } from "./PageCategories.vue?vue&type=template&id=81375060&"
import script from "./PageCategories.vue?vue&type=script&lang=js&"
export * from "./PageCategories.vue?vue&type=script&lang=js&"
import style0 from "./PageCategories.vue?vue&type=style&index=0&id=81375060&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports